///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { userRole, laneType } from "./types";

export const getUserLaneType = role => {
  if (
    role === userRole.tlPricingAnalyst ||
    role === userRole.salesRep ||
    role === userRole.assetBasedPricingUser
  ) {
    return laneType.standardTruckload;
  } else if (role === userRole.ltlPricingAnalyst) {
    return laneType.lessThanTruckload;
  } else if (role === userRole.imdlPricingAnalyst) {
    return laneType.intermodal;
  }
};

export default getUserLaneType;
